import React, { useState } from "react";
import { Link } from "react-router-dom";
import beginners_track from "../images/entrylevel1.png";
import "../styles/BeginnersTrack.css";
import { motion } from "framer-motion";
import useRegistrationStatus from "../hooks/useRegistrationStatus";
import sogo from "../images/image1.png";
import toba from "../images/image2.png";
import eri from "../images/image3.png";
import back from "../images/back.png";

const BeginnersWithExperienceTrack = () => {
  const { registrationData } = useRegistrationStatus();
  

  const data = [
    {
      question: "Module 1: Git Recap + OOP Concepts (Week 1)",
      answer:
        "Week 1: Git Recap + OOP Concepts - Refresher on version control and object-oriented programming fundamentals.",
      buttons: [{ text: "Resources", to: "/page1" }],
    },
    {
      question: "Module 2: Recap Tests and Advanced Unit Testing (Weeks 1-3)",
      answer:
        "Weeks 1-3: Recap Tests and Advanced Unit Testing. Introduction to ML testing frameworks for data integrity and bias checks.",
      buttons: [{ text: "Resources", to: "/page2" }],
    },
    {
      question: "Module 3: Projects and Python Specializations (Weeks 4-13)",
      answer:
        "Weeks 4-5: Build three custom packages (e.g., API wrappers for AI services). Weeks 6-8: Intro to Data Wrangling with Pandas, including ML data preprocessing. Week 9: API Interactions (Requests Library with AI APIs). Mini-project: Build a Python script that queries LLM APIs for automated responses.",
      buttons: [{ text: "Resources", to: "/page3" }],
    },
    {
      question: "Module 4: Automation & Web Scraping (Weeks 9-13)",
      answer:
        "Weeks 9-10: Automation - AI-driven Google Sheets (GSpread): Automate tasks and data visualization with AI insights. Weeks 11-13: Web Scraping and Data Collection - Use AI models to parse and extract insights from unstructured text.",
      buttons: [{ text: "Resources", to: "/page4" }],
    },
  ];

  const mentors = [
    {
      name: "Sogo Ogundowole",
      role: "Senior Data Engineer",
      image: sogo,
    },
    {
      name: "Oluwatoba Adesugba",
      role: "ML Engineer and Technical Writer",
      image: toba,
    },
    {
      name: "Erioluwa Asiru",
      role: "Backend Developer",
      image: eri,
    },
  ];

  return (
    <div className="beginner_wrapper" id="beginnersPage">
      <div className="beginner-container">
        <div className="beginner-content">
          <div className="back_home">
            <Link className="scrolllink" to="/#sectionToScroll">
              <img src={back} alt="goback" className="goback" />
            </Link>
          </div>

          <motion.h1
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            Beginners with <span className="oranges">Experience</span> Track
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            Fast-track your data journey with prior knowledge. For self-starters who have basic familiarity and want to accelerate their learning with advanced concepts and real-world applications.
          </motion.p>

          {!registrationData?.is_open && (
            <div className="button">
              <Link to="/FormInput" className="reserve-btns">
                <button>Join the Waitlist</button>
              </Link>
            </div>
          )}
        </div>

        <div className="faq_mentors_text">
          <h1>
            Track <span className="oranges">Modules</span>
          </h1>
        </div>

        <div className="modules-grid-container">
          <div className="modules-grid">
            {data.map((item, i) => (
              <div className="module-card" key={i}>
                <div className="module-header">
                  <h3>{item.question}</h3>
                </div>
                <div className="module-content">
                  <p>{item.answer}</p>
                </div>
                <div className="module-buttons">
                  {item.buttons.map((button, index) => (
                    <Link key={index} to={button.to} className="module-btn">
                      {button.text}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="faq_mentors_text">
          <h1>
            Meet Your <span className="oranges">Mentors</span>
          </h1>
        </div>

        <div className="mentors_container">
          {mentors.map((mentor, index) => (
            <div key={index} className="mentor_wraps">
              <div className="mentor_image_wrap">
                <img
                  src={mentor.image}
                  alt={mentor.name}
                  className="mentor_images"
                />
              </div>
              <div className="mentor_para">
                <h3>{mentor.name}</h3>
                <p>{mentor.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BeginnersWithExperienceTrack;
